<template>
  <div class="jin-attach-warp">
    <div v-for="(form, i) in info.formList" :key="i" class="el-form-reduce">
      <Delete :fix-con="{type: 'online', tem: info, idx: i}" @onDel="onDel" />
      <Upload
        title="上传附件"
        tips="支持文档、图片、压缩包、视频、音频、设计文件等格式文件，所有附件大小总和不超过50MB"
        path="annex/"
        show-file-list
        show-list
        accept=""
        :info="info"
        :size="50"
        @change="handleChange"
        @beforeUpload="beforeUpload"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fileList: [],
      annex: [],
      files: [],
      size: 0
    }
  },
  computed: {
    ...mapGetters([
      'currForm',
      'resumeCon'
    ])
  },
  watch: {
    'info.formList': {
      handler(n) {
        this.info.isAdd = !n.length
      },
      deep: true
    }
  },
  created() {
  },
  methods: {
    ...mapMutations('resume', ['SET_FORM']),
    handleChange(fileList) {
      this.size = fileList.length ? fileList.map(item => item.file.size).reduce((prev, curr) => prev + curr) : 0
      // if (!fileList.length) return
      this.annex = fileList.map(item => {
        return {
          url: item.url,
          type: item.file.name.split('.')[1],
          file: {
            name: item.file.name,
            size: item.file.size
          }
        }
      })
      // 附件保存在files字段中，否则pc版会出问题
      this.info.files = this.annex

      this.$emit('autoSave')
    },
    beforeUpload(file) {
      const size = this.size / 1024 / 1024 < 50
      if (!size) this.$message.error('上传附件大小总和不能超过50MB')
      return size
    },
    onDel() {
      this.info.files = []
      this.$emit('autoSave')
    },
    resetForm() {
      this.info.files = []
    }
  }
}
</script>
